export default __webpack_public_path__ + "static/media/martinize_go_2.b7bffd27.png";